import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { generatePath, useRouteMatch } from 'react-router-dom';
import { Box, Typography, List, ListItem } from '@mui/material';
import EventMobileCard from '../../../Events/EventMobileCard';
import useRescuerDashboardActions from '../../../../hooks/useRescuerDashboardActions';
import routes from '../../../../routes';
import { sortByDateAndTime } from '../../../../helpers/sorters';

const containerSx = {
  position: 'relative',
  height: '100%',
  width: '100%',
  overflow: 'auto',
  backgroundColor: 'background.default',
};

const EventsMobile = ({history}) => {
  const events = useSelector(state => state.entities.events);
  const { fetchEventsTab } = useRescuerDashboardActions();
  const isSCDashboard = useRouteMatch(routes.dashboardSC);
  const isRDashboard = useRouteMatch(routes.dashboardRescuer);
  const isNewDashboard = useRouteMatch(routes.mobileDashboardEvents);
  const isLoading = events.inflight;
  const eventsList = Object.values(events.byId);

  const sortEventsByDate = (a, b) => sortByDateAndTime('desc', a.date.value, b.date.value);
  const eventsByDate = eventsList.sort(sortEventsByDate);

  useEffect(() => {
    fetchEventsTab(false, false);
  }, [fetchEventsTab]);

  const handleSignupClick = (event) => {
    if (isSCDashboard) {
      return history.push(
        generatePath(routes.dashboardSCEvents, {
          eventId: event.id,
        })
      );
    }
    if (isRDashboard) {
      return history.push(
        generatePath(routes.dashboardRescuerEvents, {
          eventId: event.id,
        })
      );
    }

    if (isNewDashboard) {
      return history.push(
        generatePath(routes.mobileDashboardEventSignup, {
          eventId: event.id,
        })
      );
    }

    return null;
  };

  if (!isLoading && eventsByDate.length === 0) {
    return (
      <Box sx={containerSx}>
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            WebkitTransform: 'translate(-50%, -50%)',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
          }}
        >
          <Typography color="textSecondary" variant="h5">
            No available events
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <List sx={containerSx} subheader={<li />}>
      <li style={{ backgroundColor: 'inherit' }}>
        <Box component="ul" sx={{ marginBottom: 2, backgroundColor: 'inherit', padding: 0 }}>
          {eventsByDate.map((event) => (
            <ListItem key={`event-${event.id}`} sx={{ display: 'block', padding: 1}}>
              <EventMobileCard eventData={event} onSignupClick={() => handleSignupClick(event)} />
            </ListItem>
          ))}
        </Box>
      </li>
    </List>
  );
};

export default EventsMobile;
